module.exports = __webpack_public_path__ + "img/companies-sidebar.a2fcda98.svg";